"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.herp = void 0;
exports.herp = 'derp';
// import { rogueCamera } from '../camera/rogueCamera-sidecar'
// import { rogueMaps } from '../map/rogueMaps-sidecar'
// import { rogueMonsters } from '../monsters/rogueMonsters-sidecar'
// import { assert } from '../../../lib/assert-sidecar'
// import { rogueDungeonFeatures } from '../items/rogueDungeonFeatures-sidecar'
// import { rogueItems } from '../items/rogueItems-sidecar'
// import { rogueItemsData } from '../items/rogueItemsData-sidecar'
// import { rogueItemsData_potions } from '../items/rogueItemsData_potions-sidecar'
// import { rogueMonstersData } from '../monsters/rogueMonstersData-sidecar'
// import { rogueStats } from '../ui/rogueStats-sidecar'
// import { rogueRunner } from './rogueRunner-sidecar'
// import { rogueAanimManager } from '../anims/rogueAanimManager-sidecar'
// import { rogueGenHouse } from '../map/rogueGenHouse'
// export function createRogueTestScene() {
//   console.log('createRogueTestScene', 'init')
//   rogueMonstersData.registerAll()
//   rogueItemsData.registerAll()
//   // ROT.RNG.setSeed(1234)
//   resetGame()
//   // let map = rogueMaps.create()
//   rogueCamera.setCameraXY(-16, -16)
// }
// export function resetGame() {
//   rogueMonsters.killAllEvenIncludingThePlayer()
//   rogueMaps.killAll()
//   let player = rogueMonsters.create('@')
//   rogueStats.reset()
//   rogueStats.setMessage('Welcome to the dungeon!')
//   // Create character
//   // rogueUiCreateCharacter.open()
//   rogueItemsData_potions.rollPotionVariants()
//   // Create some basic items
//   for (let i = 0; i < 2; i++) {
//     let item = rogueMaps.spawnRandomPotion()
//     assert.notNil(item)
//     rogueItems.transferToInventory(player, item)
//   }
//   for (let i = 0; i < 2; i++) {
//     let item = rogueMaps.spawnRandomScroll()
//     assert.notNil(item)
//     rogueItems.transferToInventory(player, item)
//   }
//   nextLevel()
// }
// export function nextLevel() {
//   if (rogueMaps.hasMap()) {
//     let currentMap = rogueMaps.getCurrentMap()
//     if (currentMap) {
//       rogueMaps.destroyImages(currentMap)
//     }
//   }
//   let nextMap = rogueMaps.createEmpty()
//   let player = rogueMonsters.getPlayer()
//   if (!player) {
//     return
//   }
//   // rogueAanimManager.addAnim(rogueGenHouse())
//   rogueItems.killAllButInPlayerInventory()
//   rogueMonsters.killAllButPlayer()
//   rogueDungeonFeatures.killAll()
//   rogueMonsters.setPos(player, 3, 3)
//   // rogueMaps.placePlayerInFirstRoom(nextMap, player)
//   // rogueMaps.placeStairsInLastRoom(nextMap)
//   // rogueMaps.placeItemsInRooms(nextMap, 1.0)
//   // // Testing items
//   // rogueMaps.placeItemsInRooms(nextMap, 1.0)
//   // rogueMaps.placeItemsInRooms(nextMap, 1.0)
//   // rogueMaps.placeItemsInRooms(nextMap, 1.0)
//   // rogueMaps.placeMonstersInRooms(nextMap, 0.75)
//   // rogueCursor.setTargetMode(ERogueTargetMode.fireball)
//   rogueRunner.updateVision()
//   rogueRunner.drawAll()
// }
